import { render, staticRenderFns } from "./savings.vue?vue&type=template&id=0073ffb2&lang=pug&"
import script from "./savings.vue?vue&type=script&lang=js&"
export * from "./savings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/products/banking/mortgages?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20231205171632%2Fcomponents%2Fproducts%2Fmortgages%2Fsavings.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsListItem: require('/home/ubuntu/nuxt/bonkers/releases/20231205171632/components/widgets/list-item.vue').default})
